import React from "react";
import { Link } from "react-router-dom";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";
import { useT } from "@/context/LanguageContext";
import { Icon } from "@/components/common/Icon";
import { ArrowUpRight } from "@phosphor-icons/react";

export function Services({ services = [] }) {
  const { t } = useT();
  return (
    <section id="services" className="bg-white py-24 lg:py-32" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <SectionHeading
            overline={t("services.overline")}
            title={t("services.title")}
            subtitle={t("services.subtitle")}
          />
          <Link to="/services" className="shrink-0 text-sm font-semibold text-teal hover:underline" data-testid="services-view-all">
            {t("services.viewAll")}
          </Link>
        </div>

        <div className="mt-14 grid gap-px overflow-hidden rounded-xl border border-slate-200 bg-slate-200 sm:grid-cols-2 lg:grid-cols-3">
          {services.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 3) * 0.08}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`service-card-${s.slug}`}
                className="group flex h-full flex-col bg-white p-8 transition-colors duration-300 hover:bg-mist"
              >
                <div className="flex h-12 w-12 items-center justify-center rounded-md bg-gradient-to-br from-[#1E73BE] to-[#16B894] text-white">
                  <Icon name={s.icon} size={24} weight="duotone" />
                </div>
                <h3 className="mt-5 font-heading text-xl font-semibold text-ink">{s.title}</h3>
                <p className="mt-1 text-sm font-medium text-teal">{s.tagline}</p>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{s.summary}</p>
                <span className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-ink opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                  {t("services.learnMore")} <ArrowUpRight size={16} weight="bold" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
